import type { IAdditionalSelectors, IHostActions } from '../types';
import { MiddlewareManager } from './middleware';
import { Selectors } from './selectors';

export let selectors: Selectors;
export let middlewareManager: MiddlewareManager;

export interface IInitResult {
    selectors: Selectors;
    middlewareManager: MiddlewareManager;
}

export const init = (
    appName: string,
    additionalSelectors: IAdditionalSelectors,
    hostActions: IHostActions,
    root: string
): IInitResult => {
    selectors = new Selectors(appName, additionalSelectors);
    middlewareManager = new MiddlewareManager(selectors, hostActions, root);
    return {
        selectors,
        middlewareManager
    };
};
